import { IParameter } from "../models/parameter";

export const nullOrUndefined = (value: any) => value === null || value === undefined;

export const responsiveCarousel = {
    desktop: {
        breakpoint: { max: 4000, min: 200 },
        items: 4,
    },
};

export const localeString = "nl-BE";

export const timeDateFormat: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
};

export const dateFormat: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
};

// sumammay: boolean, name: string
export const sortBySummaryThenByName = (array: any[]): any[] => {
    return array.sort((a, b) => {
        if (a.summary && !b.summary) {
            return -1;
        }
        if (!a.summary && b.summary) {
            return 1;
        }
        return a.name.localeCompare(b.name);
    });
};
